module.exports = __webpack_public_path__ + "media/images/select2arrow-c07457739c183c845cacbf55dae2808e.jpg";